export default class room_user_status {
    state = 'online';
    lastChanged = '';
}
